import { getItemById, getTicketTypeById, isPackageTicketType } from '@vista/omnichannel-components-domain';
export const getTicketTypeLongDescription = (ticketType, i18n) => {
    if (!!ticketType.longDescription)
        return i18n.translatable(ticketType.longDescription);
    return isPackageTicketType(ticketType) ? getPackageContentsDescription(ticketType, i18n) : undefined;
};
const getPackageContentsDescription = (ticketType, i18n) => {
    const { tickets, items } = ticketType;
    const ticketDescriptions = tickets.reduce((acc, t) => {
        const childTicketType = getTicketTypeById(t.ticketTypeId);
        acc.push(`${t.quantity} ${i18n.translatable(childTicketType.description)}`);
        return acc;
    }, []);
    const itemDescriptions = items.reduce((acc, i) => {
        const item = getItemById(i.itemId);
        if (!item)
            throw new Error(`Cannot get package contents description for item with ID: ${i.itemId}`);
        acc.push(`${i.quantity} ${i18n.translatable(item.name)}`);
        return acc;
    }, []);
    return [...ticketDescriptions, ...itemDescriptions].join(', ');
};
